export enum DragItemTypes {
  ProposalItemOption = 'PROPOSAL_ITEM_OPTION',
  ProposalContentItemOption = 'PROPOSAL_CONTENT_ITEM_OPTION',
}

export enum DropItemPosition {
  Before = 'BEFORE',
  After = 'AFTER',
}
